
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from "../ui/button";
import { ArrowRight } from 'lucide-react';

export function ClosingCTASection() {
  const currentDate = new Date();
  // Set offer end date to 14 days from now
  const offerEndDate = new Date(currentDate.setDate(currentDate.getDate() + 14));
  const formattedDate = offerEndDate.toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric'
  });

  return (
    <section className="relative py-20 overflow-hidden">
      {/* Background with gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-indigo-900/90 via-purple-800/80 to-indigo-900/90 z-0">
        {/* Optional decorative stars */}
        <div className="absolute inset-0 opacity-30">
          <div className="stars" />
        </div>
      </div>

      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight"
          >
            SleepNest Is Changing Sleep Consulting—
            <span className="block mt-1">Will You Be Part of It?</span>
          </motion.h2>
          
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="text-lg text-indigo-100 mb-8 max-w-2xl mx-auto"
          >
            Join other sleep specialists who are transforming how parents access sleep support. 
            More insights, less busywork—all with a platform designed specifically for you.
          </motion.p>
          
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="flex flex-col items-center"
          >
            <Button 
              size="lg" 
              className="bg-green-500 hover:bg-green-600 text-white font-semibold rounded-full px-8 py-6 h-auto text-lg shadow-lg hover:shadow-xl transition-all flex items-center gap-2 mb-4"
              asChild
            >
              <Link to="/specialist-registration">
                Start Your Free Trial <ArrowRight className="h-5 w-5" />
              </Link>
            </Button>
            
            <p className="text-indigo-200 text-sm font-medium">
              Limited-Time Offer – Join Before {formattedDate}!
            </p>
            
            <p className="mt-6 text-indigo-200 text-sm">
              No credit card required. Cancel anytime.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}